import React from "react";

const ComingSoon = () => {
  // Inline styles
  const containerStyle = {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: "#fff",
    background: "linear-gradient(135deg, #1e3c72, #2a5298)", // Blue gradient
    padding: "0 20px",
    marginLeft: "20px",
    marginRight: "20px",
    borderRadius: "20px", // Adjust for header height
  };

  const logoStyle = { width: "160px", marginBottom: "30px" };

  const titleStyle = { fontSize: "3rem", fontWeight: "bold", marginBottom: "15px" };

  const subtitleStyle = { fontSize: "1.25rem", marginBottom: "40px", maxWidth: "500px" };

  const footerStyle = { fontSize: "0.8rem", opacity: 0.7, marginTop: "50px" };

  const buttonStyle = {
    padding: "12px 30px",
    fontSize: "1rem",
    fontWeight: "bold",
    color: "#fff",
    backgroundColor: "#ff7f50",
    border: "none",
    borderRadius: "50px",
    cursor: "pointer",
    textDecoration: "none",
    transition: "0.3s",
  };

  const buttonHoverStyle = {
    backgroundColor: "#ff6347",
  };

  return (
    <div style={containerStyle}>
      {/* <img src={`${process.env.PUBLIC_URL}/assets/images/logo2.png`} alt="Logo" style={logoStyle} /> */}

      <h1 style={titleStyle}>🚛 We’re Launching Soon!</h1>
      <p style={subtitleStyle}>
        Our logistics platform is almost ready. Stay tuned for the launch and be ready to track your shipments effortlessly.
      </p>

    
    </div>
  );
};

export default ComingSoon;
